import * as type from '../types/templates'

export const retrieveEmailTemplateList = payload => {
    return{
        type: type.REQUEST_EMAIL_TEMPLATES_CONTENT,
        payload: payload
    }
}

export const resetEmailTemplateList = () => {
    return{
        type: type.RESET_EMAIL_TEMPLATES_CONTENT
    }
}

export const retrieveSMSTemplateList = payload => {
    return{
        type: type.REQUEST_SMS_TEMPLATES_CONTENT,
        payload: payload
    }
}

export const resetSMSTemplateList = () => {
    return{
        type: type.RESET_SMS_TEMPLATES_CONTENT
    }
}

export const appendDeletionArray = payload => {
    return{
        type: type.APPEND_EMAIL_TEMPLATES_DELETION_ARRAY,
        id: payload
    }
}

export const subtractDeletionArray = payload => {
    return{
        type: type.SUBTRACT_EMAIL_TEMPLATES_DELETION_ARRAY,
        id: payload
    }
}

export const changeTemplatesModal = payload => {
    return{
        type: type.CHANGE_EMAIL_TEMPLATES_MODALS,
        modal: payload
    }
}

export const requestDeleteSingleTemplate = payload => {
    return{
        type: type.REQUEST_DELETE_SINGLE_TEMPLATE,
        details: payload
    }
}

export const resetDeleteSingleTemplate = () => {
    return{
        type: type.RESET_DELETE_SINGLE_TEMPLATE
    }
}

export const setActiveTemplateDisplay = payload => {
    return{
        type: type.SET_ACTIVE_TEMPLATE_DISPLAY,
        template: payload
    }
}

export const resetActiveTemplateDisplay = payload => {
    return{
        type: type.RESET_ACTIVE_TEMPLATE_DISPLAY
    }
}

export const requestDeleteTemplatesArray = payload => {
    return{
        type: type.REQUEST_DELETE_TEMPLATE_ARRAY,
        details: payload
    }
}

export const resetDeleteTemplatesArray = () => {
    return{
        type: type.RESET_DELETE_TEMPLATE_ARRAY
    }
}

export const setActiveTemplateDeletion = payload => {
    return{
        type: type.SET_ACTIVE_TEMPLATE_DELETION,
        data: payload
    }
}

export const resetActiveTemplateDeletion = payload => {
    return{
        type: type.RESET_ACTIVE_TEMPLATE_DELETION
    }
}